import { ref, readonly } from 'vue';

export type ToastKind = 'success' | 'info' | 'warning' | 'danger';

export type Toast = {
  id: string;
  kind: ToastKind;
  title: string;
  message?: string;
  durationMs: number;
};

const toasts = ref<Toast[]>([]);
let counter = 0;

function dismiss(id: string) {
  toasts.value = toasts.value.filter((t) => t.id !== id);
}

function show(kind: ToastKind, title: string, message?: string, durationMs = 4000): string {
  const id = `t-${++counter}-${Date.now()}`;
  toasts.value.push({ id, kind, title, message, durationMs });
  if (durationMs > 0) setTimeout(() => dismiss(id), durationMs);
  return id;
}

export function useToast() {
  return {
    toasts: readonly(toasts),
    success: (title: string, message?: string, durationMs?: number) =>
      show('success', title, message, durationMs),
    info: (title: string, message?: string, durationMs?: number) =>
      show('info', title, message, durationMs),
    warning: (title: string, message?: string, durationMs?: number) =>
      show('warning', title, message, durationMs),
    danger: (title: string, message?: string, durationMs?: number) =>
      show('danger', title, message, durationMs),
    dismiss,
  };
}
